import { ReactNode } from "react";

import { Typography } from "antd";
import { clsx } from "clsx";

import styles from "./BlockTitle.module.scss";

const nodeTitleWithFriendlyId = (nodeTitle: string, friendlyId?: string | undefined) => {
    return !!friendlyId ? `${nodeTitle} | ID ${friendlyId}` : `${nodeTitle}`;
};

type BlockTitleProps = {
    isDisabled?: boolean;
    nodeData: any;
    fallBackDisplay: string;
    icon?: JSX.Element;
    iconClassName?: string;
    children?: ReactNode;
    className?: string;
};
export function BlockTitle({
    isDisabled,
    nodeData,
    fallBackDisplay,
    icon,
    iconClassName,
    children,
    className,
}: BlockTitleProps): JSX.Element {
    const titleText = nodeTitleWithFriendlyId(fallBackDisplay, nodeData?.friendlyId);

    return (
        <div
            className={clsx(styles.nodeType, className, {
                [styles.isDisabled]: isDisabled,
            })}
        >
            {icon && <span className={iconClassName}>{icon}</span>}
            <Typography.Text className={clsx({ [styles.isDisabled]: isDisabled })} translate="no">
                {titleText}
            </Typography.Text>
            {children}
        </div>
    );
}
